import { render, staticRenderFns } from "./FloorsList.vue?vue&type=template&id=152ca8bb&scoped=true&"
import script from "./FloorsList.vue?vue&type=script&lang=js&"
export * from "./FloorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ca8bb",
  null
  
)

export default component.exports